import React from "react";

// Redux
import { useSelector } from "react-redux";

const HeaderStatus = ({
  d,
  transform,
  done,
  transformone,
  fillcolor,
  style,
  width,
  height,
  stroke,
}) => {
  const { mainTheme } = useSelector((state) => state.Layout);

  return (
    <svg
      className={`align-self-center ${
        mainTheme === "light" ? "btn nav-btn-light" : "btn nav-btn"
      }`}
      style={style}
      xmlns="http://www.w3.org/2000/svg"
      width={width || "31"}
      height={height || "31"}
      viewBox={`0 0 ${width || "31"} ${height || "31"}`}
    >
      <g fill="none" fillRule="evenodd">
        <circle cx="15.5" cy="15.5" r="15.5" fill={fillcolor} />
        <g fill="#FFF" stroke="#FFF" strokeWidth={`${stroke || "0.5"}`}>
          <path d={d} transform={transform} />
          <path d={done} transform={transformone} />
        </g>
      </g>
    </svg>
  );
};

export default HeaderStatus;
